var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 0.5H36C16.3939 0.5 0.5 16.3939 0.5 36C0.5 55.6061 16.3939 71.5 36 71.5H37C56.6061 71.5 72.5 55.6061 72.5 36C72.5 16.3939 56.6061 0.5 37 0.5Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 36C58.5 23.8497 48.6503 14 36.5 14C24.3497 14 14.5 23.8497 14.5 36C14.5 48.1503 24.3497 58 36.5 58C48.6503 58 58.5 48.1503 58.5 36Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6878 42.0575V42.1658M36.6878 33V38.6875M35.6933 26.6163C36.1442 25.7946 37.2314 25.7946 37.6824 26.6163L47.2034 43.9653C47.7041 44.8777 47.0341 45.8824 46.2088 45.8824H27.1669C26.3415 45.8824 25.6715 44.8777 26.1723 43.9653L35.6933 26.6163Z",
    stroke: "#FFFFFE",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0478cc5391d07e3ccea83f07d75a82c4.svg";
export { ForwardRef as ReactComponent };